/**
 * Dice que falta para poder guardar.
 *
 * POR QUE EXISTE
 *
 * Un boton de guardar apagado no explica nada. La usuaria intento anotar un
 * pedido, lleno el nombre y el platillo, y el boton nunca se encendio: el campo
 * de porciones estaba vacio pero mostraba un "1" de marca de agua que parecia un
 * valor ya escrito. No habia mensaje de error que leer, porque nunca se alcanzo a
 * intentar guardar.
 *
 * La regla que sale de ahi: si un boton esta deshabilitado, hay que decir por que.
 *
 * Se usa con una lista de faltantes en lugar de un solo booleano de validez,
 * justo para poder nombrarlos.
 */

interface Props {
  /** Lo que falta, en palabras. Si esta vacio no se muestra nada. */
  faltan: readonly string[];
}

/** `"a"`, `"a y b"`, `"a, b y c"`. Listas en español corriente. */
export function enumerar(partes: readonly string[]): string {
  if (partes.length <= 1) return partes[0] ?? '';
  return `${partes.slice(0, -1).join(', ')} y ${partes[partes.length - 1]}`;
}

export function Falta({ faltan }: Props) {
  if (faltan.length === 0) return null;

  return (
    <p className="text-center text-sm text-aviso" role="status">
      Falta {enumerar(faltan)} para poder guardar.
    </p>
  );
}
